<template>
  <div class="po-r w100 pt10 bg-w flex-box" v-loading="loading">
    <div class="pt10 pl10 pr10 pb10 of-y" style="width: 160px; height: 700px;">
      <div class="pt10 pb10 pl10 pr10 cu-p ellipsis role-list" :class="{ 'active': selectRole == item.id }" v-for="(item, index) in treeList" :key="index" @click="title = item.rolename, selectRole = item.id" :title="item.rolename">{{ item.rolename }}</div>
    </div>
    <div class="w100 pr20 flex-1">
      <div class="w100 mb10 font-16 tx-c">{{ title }}</div>
      <OfficeRoleUser :select-role="selectRole" :get-url="`userRole/getCollegeUserList/byRole`" @add-gcd="addGCD" @reduce-gcd="reduceGCD" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import OfficeRoleUser from "@/views/OfficeNew/OfficeRoleCollege/Comp/OfficeRoleUser";

export default {
  name: "OfficeRoleCollege",
  components: {
    OfficeRoleUser
  },
  props: [],
  data() {
    return {
      loading: false,
      title: "",

      treeList: [],
      selectRole: "",

      GCD: 0
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  created() {},
  mounted() {
    this.fetchTreeList();
  },
  methods: {
    fetchTreeList() {
      this.loading = true;

      this.$http
        .post("userRole/getCollegeRoleList", this.$qs.stringify({}))
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.treeList = data.resData;
            if (this.treeList.length) {
              this.selectRole = this.treeList[0].id;
              this.title = this.treeList[0].rolename;
            }
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.loading = false;
        });
    },
    addGCD() {
      this.GCD++;
    },
    reduceGCD() {
      this.GCD--;
    }
  },
  watch: {
    GCD(value) {
      if (value > 0) {
        this.loading = true;
      } else {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.role-list:hover {
  background: #eee;
}

.role-list.active {
  background: #e4f1fc;
}
</style>
